import { useTranslations } from 'next-intl';
import cx from 'classnames';
import {
  CatIconUndo,
  CatHeading,
  CatButton
} from 'components/blocks-components';
import { useBreakpoint } from 'components/pcc-components';
import { Image } from 'components/image';
import { PAGE_BREAKPOINTS, ERROR_IMAGE } from 'constants/common';
import styles from './error-message.module.scss';

interface ErrorMessageProps {
  onRetry: () => void;
  retryButtonLabel: string;
  errorMessage: string;
}

const ErrorMessage = ({
  onRetry,
  retryButtonLabel,
  errorMessage
}: ErrorMessageProps) => {
  const t = useTranslations();
  const isBLG = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  const headingVariant = isBLG ? 'label-lg' : 'label';

  return (
    <div
      className={cx(
        'd-flex align-items-center flex-column justify-content-center gap-2',
        styles['error-section']
      )}
    >
      <div className={styles['error-image']}>
        <Image src={ERROR_IMAGE} alt="error-image" fill />
      </div>
      <CatHeading variant={headingVariant}>
        <span
          className={cx(
            'd-flex text-center justify-content-center u-color--Black',
            styles['error-heading-width']
          )}
        >
          {t(errorMessage)}
        </span>
      </CatHeading>
      <CatButton variant="ghost" onClick={onRetry}>
        <CatIconUndo color="information" slot="before" />
        {t(retryButtonLabel)}
      </CatButton>
    </div>
  );
};
export default ErrorMessage;
